/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Auf michelin.com ändern`
};

const en_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Edit on michelin.com`
};

const es_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Modificar en michelin.com`
};

const fr_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Modifier sur michelin.com`
};

const it_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Modifica su michelin.com`
};

const nl_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Aanpassen op michelin.com`
};

const pt_profile__tabs__information__modify = /** @type {(inputs: {}) => string} */ () => {
	return `Alterar em michelin.com`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__information__modify(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__information__modify", locale)
	if (locale === "de") return de_profile__tabs__information__modify(inputs)
	if (locale === "en") return en_profile__tabs__information__modify(inputs)
	if (locale === "es") return es_profile__tabs__information__modify(inputs)
	if (locale === "fr") return fr_profile__tabs__information__modify(inputs)
	if (locale === "it") return it_profile__tabs__information__modify(inputs)
	if (locale === "nl") return nl_profile__tabs__information__modify(inputs)
	return pt_profile__tabs__information__modify(inputs)
};